import React, { Component } from 'react'
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { getSession1, initAbandonedSession } from '../../actions/paper';
import TopNav from '../includes/TopNav';

class InitAbandon extends Component {
    constructor(props) {
        super(props)
        this.state = {'canMoveOn': false, 'checkedSession': false}
    }
    componentWillMount(props) {
        this.props.dispatch(getSession1(function(data){
            if(data.body.doc_id && data.body.doc_id == this.props.match.params.docId) {
                // nothing to do - we can continue with the same session
                this.setState({'canMoveOn': true, 'checkedSession': true});
            } else if((!data.body.doc_id || data.body.doc_name == "") && this.props.match.params.docId) {
                // init session with known docId
                this.props.dispatch(initAbandonedSession(this.props.match.params.docId, function(res){
                    var newState = {
                        'checkedSession': true
                    }
                    if(res) {
                        newState.canMoveOn = true;
                    }
                    this.setState(newState);
                }.bind(this)));
            } else if(data.body.doc_id && data.body.doc_id != this.props.match.params.docId) { 
                // doc ID in session different from doc ID from abandon - stay on this page, show the message
            } else {
            }
        }.bind(this)));
    }
    render() {
        if(this.props.match.params.refCode) {
            window.localStorage.setItem('refCode', this.props.match.params.refCode);
        }
        if(this.state.checkedSession && this.state.canMoveOn) {
            this.props.history.push('/step4');
        } else if(this.state.checkedSession && !this.state.canMoveOn) {
            this.props.history.push('/get-started');
        }
        return(<div>
            <TopNav></TopNav>
            <section className="steps top_section">
                <div>
                    Discount code has been applied to your session.<br />
                    See details at checkout.
                </div>
            </section>
        </div>)
    }
}
export default connect( ({User}) => ({User}) ) (InitAbandon)


// WEBPACK FOOTER //
// ./src/components/steps/InitAbandon.js